import { MifeParcel } from '@/components/MifeParcel';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/calculators/affordability-calculator')({
  component: () => <MifeParcel />,
});
